import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import styles from "./services.module.scss";
import { Link } from "react-router-dom";

const introduction = () => {
  return (
    <Typography className={styles.details}>
      The goal of GASSC Educational Activity is to promote and provide
      assistance in continuing education, domain knowledge, and skills for its
      members. This program addresses the needs of members who wish to update,
      upgrade, or learn totally new domain knowledge and skills for changing
      their professional profile to continue being employed. The Education
      Activity also includes an initiative to institute and maintain a Golden
      Agers Mentoring program along with a hiring and internship referral
      service.The objectives, key success factors, and tactical activity plan
      for 2018 is provided below.
    </Typography>
  );
};

const objectives = () => {
  return (
    <Typography className={styles.details}>
      <ul style={{ paddingRight: 0, margin: 0 }}>
        <li>
          Provide a 'Mentee Portal' on education, domain knowledge, and skills -
          Inbound
        </li>
        <li>
          Provide a 'Mentoring Portal' on education, domain knowledge, and
          skills - Outbound
        </li>
        <li> Build alliances for hiring and intern opportunities</li>
        <li>
          Build a team of Service Providers (sevaka) for educational activities
        </li>
        <li> Create 'Mailing List' for educational activities</li>
        <li> Maintain an up to date status of ESA tab on GASSC website</li>
      </ul>
    </Typography>
  );
};
const succesFactores = () => {
  return (
    <Typography className={styles.details}>
      <ul style={{ paddingRight: 0, margin: 0 }}>
        <li>Promotion of Educational Activity</li>
        <li>Effectiveness of Service Providers (sevaka)</li>
        <li>Signup of mentors for mentees</li>
        <li>Signup of mentees for mentors</li>
        <li>Signup of alliances for referrals</li>
        <li>Signup of Service Providers (sevaka)</li>
      </ul>
    </Typography>
  );
};

const activityPlan = () => {
  return (
    <Typography className={styles.details}>
      <ol style={{ paddingRight: 0, margin: 0 }}>
        <li>Create Service Provider job description</li>
        <li>Promote Service Provider requirement</li>
        <li>
          Identify the Service Provider leader to manage the Service
          Provisioning program
        </li>
        <li>Conduct initial and periodic Service Provider signup program</li>
        <li>
          Create the Service Provider team with specific defined service
          (responsibilities)
        </li>
        <li>
          Identity mentors for at least two areas of education, domain
          knowledge, and skills
        </li>
        <li>Create ‘Mentor-Mentee’ rules of engagement</li>
        <li>Promote mentors on ‘Mentor Platform’</li>
        <li>Create Mentee Registration Form</li>
        <li>Create list of potential employers for hiring and internships</li>
        <li>Create mailing list for educational activities</li>
        <li>
          Create quarterly report of ESA activities for GASSC leadership team
        </li>
      </ol>
    </Typography>
  );
};
const earthQuake = () => {
  return (
    <div className={styles.positioncontent}>
      <Grid className={styles.download}>
        <div className={styles.imageposition}>
          <div className={styles.positionicon}>
            <img src="/images/Ellipse_broucher.svg" />
            <img src="/images/ga2.svg" className={styles.downloadicon} />
          </div>
          <Typography className={styles.downloadtext}>
            <a
              href="http://image.msmail.morganstanley.com/lib/fe9413737562077971/m/1/FEMA_B-526_Earthquake_Safety_Checklist_110217_508.pdf"
              target="_blank"
              style={{ textDecoration: "none", color: "#882E14" }}
            >
              {" "}
              Safety Checklist
            </a>
          </Typography>
        </div>
      </Grid>
      <Grid className={styles.downloadbroucher}>
        <div className={styles.imageposition}>
          <div className={styles.positionicon2}>
            <img src="/images/Ellipse_broucher.svg" />
            <img src="/images/ga1.svg" className={styles.artical} />
          </div>
          <Typography className={styles.downloadtext}><a href="https://www.ready.gov/earthquakes" target="_blank" style={{textDecoration:"none",color:"#882E14"}}>What to do</a> </Typography>
        </div>
      </Grid>
    </div>
  );
};
const headingActivities = () => {
  return (
    <Typography className={styles.headingActivities}>
      <span>
        <Link to="/educational">Educational Activities</Link>
      </span>{" "}
      |{" "}
      <span>
        <Link to="/educational">Spiritual Activities</Link>
      </span>{" "}
      |{" "}
      <span>
        <Link to="/educational">Health & Wellness</Link>
      </span>{" "}
      |{" "}
      <span>
        <Link to="/educational">In House Support</Link>
      </span>{" "}
      |{" "}
      <span>
        <Link to="/educational">Funeral Services</Link>
      </span>{" "}
      |{" "}
      <span>
        <Link to="/educational">Retirement Planning</Link>
      </span>{" "}
    </Typography>
  );
};

const EducationalActivities = () => {
  return (
    <Box className={styles.goldenAgersActivityConatiner}>
      
      <Box className={styles.singleSection}>
        <Typography className={styles.mainheadings}>Introduction</Typography>
        {introduction()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography className={styles.mainheadings}>Objectives</Typography>
        {objectives()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography className={styles.mainheadings}>Success Factors</Typography>
        {succesFactores()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography className={styles.mainheadings}>
          2018 Activity Plan
        </Typography>
        {activityPlan()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography className={styles.mainheadings}>Earth Quake</Typography>
        {earthQuake()}
      </Box>
    </Box>
  );
};

export default EducationalActivities
;
